import React, { useState, useEffect } from 'react';
import ImageFilter from '../AnalysisOfDiscussions/ImageFilter';
import PageTabs from '../components/PageTabs';
import './Pages.scss';
import { emotiveTrendsStore } from '../Analysis_A/EmotiveTrendsStore';
import { EMOTIVE_THEMES } from '../utils/themes';
import { communityEmotionsStore } from '../Analysis_A/CommunityEmotionsStore';
import CommunityEmotionsCombined from '../Analysis_A/CommunityEmotionsCombined';
import { PAGE_KEYS } from '../utils/pageAccess';
import FrustrationIndicator from '../Analysis_A/FrustrationIndicator';

function EmotiveAnalysis({ allowedPages = [] }) {
  const [activeTab, setActiveTab] = useState('compare_by_groups');

  const tabs = [
    { id: 'compare_by_groups', label: 'Сравнение по сообществам', page: PAGE_KEYS.EMOTIVE_COMMUNITIES },
    { id: 'compare_average', label: 'Сравнение эмоций в среднем', page: PAGE_KEYS.EMOTIVE_AVERAGE },
    { id: 'reasons', label: 'Причины эмоций', page: PAGE_KEYS.EMOTIVE_REASONS },
    { id: 'frustration', label: 'Фрустрация', page: PAGE_KEYS.EMOTIVE }
  ];

  const filteredTabs = tabs.filter((tab) => {
    if (!allowedPages.includes(tab.page)) return false;
    if (tab.id !== 'reasons') return true;
    return (
      allowedPages.includes(PAGE_KEYS.EMOTIVE_REASONS_DATA) ||
      allowedPages.includes(PAGE_KEYS.EMOTIVE_REASONS_WORDS)
    );
  });
  const canRenderActiveTab = filteredTabs.some((tab) => tab.id === activeTab);
  const firstAllowedTabId = filteredTabs[0]?.id;

  useEffect(() => {
    if (firstAllowedTabId && !canRenderActiveTab) {
      setActiveTab(firstAllowedTabId);
    }
  }, [canRenderActiveTab, firstAllowedTabId]);

  return (filteredTabs.length > 0 ? (
    <div className="top-level-page-container">
      <PageTabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={filteredTabs} />
      <div className="page-content">
        {canRenderActiveTab && activeTab === 'compare_by_groups' && (
          <CommunityEmotionsCombined
            key="communities"
            primaryStore={communityEmotionsStore}
            secondaryStore={emotiveTrendsStore}
            themes={EMOTIVE_THEMES}
            viewMode="communities"
          />
        )}
        {canRenderActiveTab && activeTab === 'compare_average' && (
          <CommunityEmotionsCombined
            key="average"
            primaryStore={communityEmotionsStore}
            secondaryStore={emotiveTrendsStore}
            themes={EMOTIVE_THEMES}
            viewMode="average"
          />
        )}
        {canRenderActiveTab && activeTab === 'reasons' && (
          <ImageFilter allowedPages={allowedPages} />
        )}
        {canRenderActiveTab && activeTab === 'frustration' && (
          <FrustrationIndicator />
        )}
      </div>
    </div>
  ) : (
    <div className="top-level-page-container">
      <h1>У вас нет доступа к этой странице</h1>
    </div>
  ));
}

export default EmotiveAnalysis;
